import { Item } from "../redux/type";
import { API } from "../utils/constants";

export const verifyAdminPassword = async (uid: string) => {
  try {
    const response = await fetch(API + "/admin/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        uid,
      }),
    });

    const data = await response.json();

    if (data.error) {
      return false;
    }

    return data.authenticated;
  } catch (error) {
    return false;
  }
};

export const updateItem = async (
  uid: string,
  itemId: string,
  updates: Item
) => {
  const response = await fetch(`${API}/admin/updateItem`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ uid, itemId, updates }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Failed to update item");
  return data;
};

export const deleteItem = async (uid: string, itemId: string) => {
  const response = await fetch(`${API}/admin/deleteItem`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ uid, itemId }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Failed to delete item");
  return data;
};

export const getAdminItems = async (uid: string): Promise<Item[]> => {
  const response = await fetch(`${API}/admin/items`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ uid }),
  });
  if (!response.ok) throw new Error("Failed to fetch items");
  return await response.json();
};

export const createItem = async (uid: string, itemData: Omit<Item, "_id">) => {
  const response = await fetch(`${API}/admin/createItem`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ uid, ...itemData }),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Failed to create item");
  return data;
};

export const getPlatformStats = async (uid: string, timeRange: string) => {
  try {
    const response = await fetch(API + "/admin/stats", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        uid,
        timeRange,
      }),
    });

    const data = await response.json();

    if (data.error) {
      console.error("Error fetching stats:", data.error);
      return null;
    }

    return data;
  } catch (error) {
    console.error("Network error fetching stats:", error);
    return null;
  }
};

export const getUserStats = async (userId: string, uid: string) => {
  try {
    const response = await fetch(API + `/admin/userStats`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId,
        uid,
      }),
    });

    const data = await response.json();

    if (data.error) {
      console.error("Error fetching user stats:", data.error);
      return null;
    }

    return data;
  } catch (error) {
    console.error("Network error fetching user stats:", error);
    return null;
  }
};

export const getSettings = async (uid: string) => {
  try {
    const response = await fetch(API + "/admin/getSystemSettings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        uid,
      }),
    });

    const data = await response.json();

    if (data.error) {
      console.error("Error fetching settings:", data.error);
      return null;
    }

    return data;
  } catch (error) {
    console.error("Network error fetching settings:", error);
    return null;
  }
};

// /api/admin/updateSystemSettings

export const updateSettings = async (uid: string, settings: any) => {
  try {
    const response = await fetch(API + "/admin/updateSystemSettings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        uid,
        settings,
      }),
    });

    const data = await response.json();

    if (data.error) {
      console.error("Error updating settings:", data.error);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Network error updating settings:", error);
    return false;
  }
};

export const getMaintenanceMode = async () => {
  try {
    const response = await fetch(API + "/getMaintenanceMode", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (data.error) {
      console.error("Error fetching maintenance mode:", data.error);
      return null;
    }

    return data.maintenanceMode;
  } catch (error) {
    console.error("Network error fetching maintenance mode:", error);
    return null;
  }
};

export const promoteToAdmin = async (
  uidToPromote: string | number,
  uid: string
) => {
  const response = await fetch(API + "/admin/promote", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      uidToPromote,
      uid: uid,
    }),
  });

  const data = await response.json();

  if (data.error) {
    return false;
  }

  return data.success;
};

export const demoteUser = async (uidToDemote: string | number, uid: string) => {
  const response = await fetch(API + "/admin/demote", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      uidToDemote,
      uid,
    }),
  });

  const data = await response.json();

  if (data.error) {
    return false;
  }
  return data.success;
};
